import type {
  Broadcast,
  BroadcastInput,
  BroadcastPage,
  NotificationPage,
  ReadAllResponse,
  RecipientCountResponse,
  UnreadCountResponse,
} from '@/types/notifications';
import { httpClient } from './httpClient';

const BASE = '/api/notification';

export interface ListNotificationsParams {
  cursor?: string;
  limit?: number;
  unreadOnly?: boolean;
}

export async function listNotifications(
  params: ListNotificationsParams = {},
): Promise<NotificationPage> {
  const response = await httpClient.get<NotificationPage>(`${BASE}/list`, {
    params: {
      cursor: params.cursor || undefined,
      limit: params.limit,
      unread_only: params.unreadOnly ? true : undefined,
    },
  });

  return response.data;
}

export async function getUnreadCount(): Promise<number> {
  const response = await httpClient.get<UnreadCountResponse>(`${BASE}/unread-count`);

  return response.data.count;
}

export async function markNotificationRead(id: string): Promise<void> {
  await httpClient.post(`${BASE}/${encodeURIComponent(id)}/read`);
}

export async function markAllNotificationsRead(): Promise<number> {
  const response = await httpClient.post<ReadAllResponse>(`${BASE}/read-all`);

  return response.data.updated;
}

const BROADCASTS = `${BASE}/admin/broadcasts`;

export interface ListBroadcastsParams {
  cursor?: string;
  limit?: number;
}

export async function listBroadcasts(params: ListBroadcastsParams = {}): Promise<BroadcastPage> {
  const response = await httpClient.get<BroadcastPage>(BROADCASTS, {
    params: { cursor: params.cursor || undefined, limit: params.limit },
  });

  return response.data;
}

export async function getBroadcast(id: string): Promise<Broadcast> {
  const response = await httpClient.get<Broadcast>(`${BROADCASTS}/${encodeURIComponent(id)}`);

  return response.data;
}

export async function getBroadcastRecipientCount(): Promise<number> {
  const response = await httpClient.get<RecipientCountResponse>(`${BROADCASTS}/recipient-count`);

  return response.data.count;
}

export async function createBroadcast(input: BroadcastInput): Promise<Broadcast> {
  const response = await httpClient.post<Broadcast>(BROADCASTS, input);

  return response.data;
}

export async function updateBroadcast(id: string, input: BroadcastInput): Promise<Broadcast> {
  const response = await httpClient.put<Broadcast>(
    `${BROADCASTS}/${encodeURIComponent(id)}`,
    input,
  );

  return response.data;
}

export async function withdrawBroadcast(id: string): Promise<void> {
  await httpClient.delete(`${BROADCASTS}/${encodeURIComponent(id)}`);
}
